import React from 'react';

import { CheckmarkOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack } from '@lyearn/ui';

import Tag from '../Tag';
import { OptionItemProps } from './types';

const renderSelectedIcon = (selected: boolean) => {
  if (!selected) {
    return null;
  }
  return <CheckmarkOutline className="h-16 w-16 flex-shrink-0 fill-current text-icon-active" />;
};

const OptionItem = (props: OptionItemProps) => {
  const { option, state } = props;

  return (
    <Stack alignItems="center" className="w-full" gapX={4} justifyContent="between">
      <Box className={cn('flex-1', state.selected ? 'w-4/5' : 'w-full')}>
        <Tag option={option} />
      </Box>
      {renderSelectedIcon(state.selected)}
    </Stack>
  );
};

export default OptionItem;
